import { render, staticRenderFns } from "./retrievepwd.vue?vue&type=template&id=e05d48ca&scoped=true"
import script from "./retrievepwd.vue?vue&type=script&lang=js"
export * from "./retrievepwd.vue?vue&type=script&lang=js"
import style0 from "./retrievepwd.vue?vue&type=style&index=0&id=e05d48ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e05d48ca",
  null
  
)

export default component.exports